(() => {
  if (window.VelmaraPajamaShipping) {
    window.VelmaraPajamaShipping.refresh();
    return;
  }

  function tomorrowLabel(now = new Date(), locale = 'it-IT') {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const tomorrow = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day) + 1, 12));
    return new Intl.DateTimeFormat(locale || 'it-IT', {
      timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long'
    }).format(tomorrow);
  }

  function refresh() {
    document.querySelectorAll('[data-vm-pajama-shipping]').forEach(banner => {
      const date = banner.querySelector('[data-vm-pajama-date]');
      const label = tomorrowLabel(new Date(), banner.dataset.dateLocale);
      if (date && date.textContent !== label) date.textContent = label;
    });
  }

  window.VelmaraPajamaShipping = { refresh, tomorrowLabel };
  refresh();
  window.setInterval(refresh, 60000);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
})();
